import { Button } from '@mui/material';
import ShowMoreDrawer from 'pages/Dashboard/ShowMoreDrawer';
import ResendInviteForm from 'pages/Dashboard/components/ResendInviteForm';
import { INVITE_DRAWER_TYPE } from 'pages/Dashboard/enums';
import { PatientObj } from 'pages/Dashboard/types/patient.types';
import React, { memo, useCallback, useState, ReactNode } from 'react';
import { MixpanelEventName } from 'utils/constants';
import { trackMixpanelEvent } from 'utils/utilMethods';

interface TProps {
  patient: PatientObj;
  renderResendInviteButton?: (open: () => void) => ReactNode;
  callbackFn?: () => void;
}

function ResendInvite({ patient, renderResendInviteButton, callbackFn }: TProps) {
  const [drawerItem, setDrawerItem] = useState('');
  const openDrawer = useCallback(() => {
    if (!callbackFn) {
      trackMixpanelEvent(MixpanelEventName.RESEND_INVITE_BUTTON_CLICKED, {
        location: 'signup_pending_tab',
      });
    }
    setDrawerItem(INVITE_DRAWER_TYPE.RESEND_INVITE);
  }, [callbackFn]);

  const closeDrawer = useCallback(() => {
    setDrawerItem('');
  }, []);

  return (
    <>
      <ShowMoreDrawer drawerItem={drawerItem} closeDrawer={closeDrawer}>
        <ResendInviteForm
          patient={patient}
          drawerItem={drawerItem}
          closeDrawer={closeDrawer}
          drawerMode
          callbackFn={callbackFn}
        />
      </ShowMoreDrawer>
      {renderResendInviteButton ? (
        renderResendInviteButton(openDrawer)
      ) : (
        <Button color='primary' variant='outlined' size='small' onClick={openDrawer}>
          {patient?.onboardingMetadata?.status === 'INVITE_DELIVERY_FAILED' ? 'FIX ERROR' : 'RESEND INVITE'}
        </Button>
      )}
    </>
  );
}

export default memo(ResendInvite);
